import { NgModule } from '@angular/core';
import { FilterColumn } from './column-filter.pipe';


export class FilterColumnModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [FilterColumn],
  exports: [FilterColumn]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
